import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { Promise } from "es6-promise-polyfill";

// $(document).ready(function() {
//   if (!Abacus.PreventDefault.ResourceSearchWidget) {
//     $(".widget-resource-search").each(function() {
//       Abacus.ResourceSearchWidget = new ResourceSearchWidget(this);
//     });
//     //    $(window).trigger("abacus:loadcontent:complete", [self.element]);
//     //    $(window).trigger("abacus:customwidget:complete", [self.element]);
//   }
// });

$(window).on("abacus:customwidget:complete", function(evt, context) {
  if (context.hasClass("widget-resource-search")&&!context.hasClass("widget-resource-search-applied")) {
    let element = (context.find(".widget")[0]||context.is('.widget-resource-search')&&context[0]);
    $(element).addClass('widget-resource-search-applied');
    Abacus.ResourceSearchWidget = new ResourceSearchWidget(element);
  }
});

class ResourceSearchWidget extends Class {
    constructor(element, options) {
      super();
      this.element = $(element);
      this.setOptions(options);
      this.setUpEvents();
    }
  
    setUpEvents() {
      var _that=this;
      var ajaxurl=(_that.element[0]&&_that.element[0].getAttribute('data-search-url')||'');
      var textbox=_that.element.find(".textbox");

      $(textbox).on('focus',function(e){
          _that.element.addClass('widget-active');
      });

      _that.element.find('.checkbox-container input[type="checkbox"]').on("change", function(e) {
        var target=e.target;
        if(!target.value){
          _that.element.find('.checkbox-container>input[type="checkbox"]').each(function(index,elem){
            if(elem.value){
              elem.checked=!target.checked;
            }
          });
        }else{
          _that.element.find('.checkbox-container input[type="checkbox"][value=""]').prop('checked',true);
          _that.element.find('.checkbox-container input[type="checkbox"]').each(function(index,elem){
            if(elem.value&&elem.checked){
              _that.element.find('.checkbox-container input[type="checkbox"][value=""]').prop('checked',false);
              return;
            }
          });
        }
      });
      

      _that.element.find('.button-search').on("click", function(e) {
          proccessQueryAndRedirect(e);
      });
      _that.element.find('.button-search').on('keydown', function(e){
        if(e.which == 9){
          _that.element.removeClass('widget-active');
        }
      })
      
      $(textbox).on('keydown', function(e) {
        if(e.shiftKey && e.which == 9){
          _that.element.removeClass('widget-active');
        }
        if(e.which == 13) {
          proccessQueryAndRedirect(e);
        }
      });

      $(document.body).on('click',function(e) {
        if($(e.target).is('input.textbox')) return;
        if(!e.target || (!($(e.target).parents('.resource-search').hasClass('categories-container')||$(e.target).is('.resource-search.categories-container')) && (!$(e.target).parents('.widget').length||$(e.target).parents('.widget').hasClass('widget-active')))) {
          $('.widget-resource-search').removeClass('widget-active');
        }
      });

      var proccessQueryAndRedirect=function(e) {
        var metrics = [];
        if(!_that.element.find('.checkbox-container>input[value=""]:checked').length){
          _that.element.find('.checkbox-container>input').each(function(index,elem){
            if(elem.checked&&elem.value){
              metrics.push((elem.getAttribute('name')||'')+'|'+elem.value);
            }
          });
        }
        document.location.href=ajaxurl+(ajaxurl.indexOf('?')!=-1?'&':'?')+'qkeyword='+encodeURIComponent(textbox.val())+'&parametrics='+encodeURIComponent(metrics.join(','));
      };
    }
  }
  
  export { ResourceSearchWidget };


// WEBPACK FOOTER //
// ./Javascript/core/classes/widgets/resource-search.class.js